var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11V22M4 22V11M14 22V17C14 16.4477 13.5523 16 13 16H11C10.4477 16 10 16.4477 10 17V22M9 4.5V2.1C9 2.04477 8.95523 2 8.9 2H6.1C6.04477 2 6 2.04477 6 2.1V7M1 22H23M2.2606 11H21.7394C21.8311 11 21.8744 10.887 21.8063 10.8257L12.669 2.60207C12.2887 2.25979 11.7113 2.25979 11.331 2.60207L2.1937 10.8257C2.12558 10.887 2.16895 11 2.2606 11Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.b0564afdec86657dc63ec91145f4a36f.svg";
export { ForwardRef as ReactComponent };